import React from 'react';

import cn from 'classnames';
import { EmblaCarouselType } from 'embla-carousel';

import cls from './EmblaControlButtons.module.css';

interface EmblaControlButtonsProps {
    emblaThumbsApi: EmblaCarouselType;
    emblaMainApi: EmblaCarouselType;
    selectedIndex: number;
    slides: {
        image: string;
        descriptionSlot?: React.ReactNode;
    }[];
    nextIcon?: React.ReactNode;
    prevIcon?: React.ReactNode;
}

export const EmblaControlButtons = ({
    emblaThumbsApi,
    emblaMainApi,
    selectedIndex,
    slides,
    prevIcon,
    nextIcon,
}: EmblaControlButtonsProps) => {
    const isDisabledPrevButton = selectedIndex === 0;
    const isDisabledNextButton = selectedIndex === slides.length - 1;
    const onPrevSlide = () => {
        if (!emblaMainApi || !emblaThumbsApi) return;
        emblaMainApi.scrollTo(selectedIndex - 1);
    };
    const onNextSlide = () => {
        if (!emblaMainApi || !emblaThumbsApi) return;
        emblaMainApi.scrollTo(selectedIndex + 1);
    };
    return (
        <>
            {prevIcon && (
                <button
                    disabled={isDisabledPrevButton}
                    className={cn(cls.button, cls.prev)}
                    type="button"
                    onClick={onPrevSlide}
                >
                    {prevIcon}
                </button>
            )}
            {nextIcon && (
                <button
                    disabled={isDisabledNextButton}
                    className={cn(cls.button, cls.next)}
                    type="button"
                    onClick={onNextSlide}
                >
                    {nextIcon}
                </button>
            )}
        </>
    );
};
